export default __webpack_public_path__ + "static/media/reject.de80396b.svg";